import {
    IProductsCategoryTitem,
    IProductsCategoryTypes, ProductsCategoryTypesResponse
} from '@/entity/warehouse/Products/Category/Category.types';

export class ProductsCategory implements  IProductsCategoryTypes {
    id: number | null;
    name: string
    parent_id: number | null
    salon_id: number | null | undefined;
    archived: boolean
    article: string
    comment: string
    children: IProductsCategoryTitem
    constructor (data: ProductsCategoryTypesResponse) {
            this.id = data.id
            this.name = data.name
            this.parent_id = data.parent_id
            this.salon_id = data.salon_id
            this.archived = data.archived
            this.article = data.article
            this.comment = data.comment
            this.children = data.children
    }
}

export default class ProductsCategoryTypes implements IProductsCategoryTypes {
    id: number | null
    name: string
    parent_id: number | null
    salon_id: number | null | undefined
    archived: boolean
    article: string
    comment: string
    children: IProductsCategoryTitem

    constructor(data:IProductsCategoryTypes) {
        this.id = data.id
        this.name = data.name
        this.parent_id = data.parent_id
        this.salon_id = data.salon_id
        this.archived = data.archived
        this.article = data.article
        this.comment = data.comment
        this.children = data.children
    }
}